import styled from 'styled-components'

import { fluidSpacingFunc } from '~styles/helpers'

const UnorderedListBlock = styled.ul`
  ${fluidSpacingFunc([{ property: 'margin', values: [0, 0, 3] }])};
`

export default UnorderedListBlock
